/* eslint-disable import/no-import-module-exports */
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './_index.scss';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'app/store';
import './index.css';
import { Provider } from 'react-redux';
import { AuthProvider } from 'context/AuthContext';
import { initFavicon } from '@rcw/favicon';
import { LocaleProvider } from './i18n/LocaleContext';
import { App } from './App';

initFavicon({
  light: `${process.env.REACT_APP_PUBLIC_URL}/favicon.ico`,
  dark: `${process.env.REACT_APP_PUBLIC_URL}/favicon-dark.svg`,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <Provider store={store}>
        <AuthProvider>
          <LocaleProvider>
            <App />
          </LocaleProvider>
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>,
);
